module.exports = __webpack_public_path__ + "img/down-arrow.291c60c5.svg";